import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import theme from './styles/theme';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Header from './components/common/Header';

// Public Pages
import HomePage from './components/public/HomePage';
import ArticlePage from './components/public/ArticlePage';
import ArchivePage from './components/public/ArchivePage';
import SectionPage from './components/public/SectionPage';
import SearchPage from './components/public/SearchPage';

// Admin Pages
import Login from './components/admin/Login';
import AdminDashboard from './components/admin/AdminDashboard';
import ArticleEditor from './components/admin/ArticleEditor';
import WorkflowManager from './components/admin/WorkflowManager';
import CommentModeration from './components/admin/CommentModeration';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <Router>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <GlobalStyles />
          <Header />
          
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/article/:id" element={<ArticlePage />} />
            <Route path="/news" element={<SectionPage section="news" />} />
            <Route path="/sports" element={<SectionPage section="sports" />} />
            <Route path="/features" element={<SectionPage section="features" />} />
            <Route path="/opinion" element={<SectionPage section="opinion" />} />
            <Route path="/archive" element={<ArchivePage />} />
            <Route path="/archive/:id" element={<ArticlePage />} />
            <Route path="/search" element={<SearchPage />} />
            
            {/* Auth Routes */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected Admin Routes */}
            <Route 
              path="/admin" 
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/article/:id" 
              element={
                <ProtectedRoute>
                  <ArticleEditor />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/workflow" 
              element={
                <ProtectedRoute>
                  <WorkflowManager />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/admin/comments" 
              element={
                <ProtectedRoute>
                  <CommentModeration />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </AuthProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
